// Configuración de versiones de la aplicación
// Cambiar aquí cada vez que se haga un release

export const APP_VERSION = '1.0.2-beta';

// Configuración de limpieza de cache
export const CACHE_CONFIG = {
  // Versión mínima compatible (cache se limpia si la versión guardada es menor)
  MIN_COMPATIBLE_VERSION: '1.0.0',
  
  // Claves específicas de AsyncStorage que siempre se limpian
  STORAGE_KEYS_TO_CLEAR: [
    'reports',
    'userData', 
    'appState',
    'cache',
    'tempData',
    'formData',
    'navigationState',
    'userPreferences',
    'lastSync',
    'offlineData'
  ],
  
  // Patrones de claves que se limpian automáticamente
  KEY_PATTERNS_TO_CLEAR: [
    'report_',
    'data_',
    'cache_',
    'temp_',
    'user_',
    'form_',
    'nav_',
    'sync_',
    'offline_'
  ],
  
  // Claves que NO se limpian (configuración persistente)
  PERSISTENT_KEYS: [
    'app_version',
    'user_id',
    'auth_token',
    'settings',
    'onboarding_completed'
  ]
};

// Configuración de desarrollo
export const DEV_CONFIG = {
  // En desarrollo, limpiar cache más agresivamente
  AGGRESSIVE_CLEANING: true,
  
  // Mostrar logs detallados
  VERBOSE_LOGGING: true,
  
  // Permitir limpieza manual
  ALLOW_MANUAL_CLEAR: true,
  
  // Forzar limpieza en cada reload (solo para testing extremo)
  FORCE_CLEAR_ON_RELOAD: false
};

// Función para verificar si una versión es compatible
export const isVersionCompatible = (savedVersion, currentVersion = APP_VERSION) => {
  if (!savedVersion) return false;
  
  try {
    const saved = savedVersion.split('.').map(Number);
    const current = currentVersion.split('.').map(Number);
    const minCompatible = CACHE_CONFIG.MIN_COMPATIBLE_VERSION.split('.').map(Number);
    
    // Si la versión guardada es menor que la mínima compatible, limpiar cache
    for (let i = 0; i < Math.min(saved.length, minCompatible.length); i++) {
      if (saved[i] < minCompatible[i]) return false;
      if (saved[i] > minCompatible[i]) break;
    }
    
    return true;
  } catch (error) {
    console.error('Error parsing version:', error);
    return false;
  }
};

// Función para obtener información de la versión
export const getVersionInfo = () => ({
  current: APP_VERSION,
  minCompatible: CACHE_CONFIG.MIN_COMPATIBLE_VERSION,
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  buildTime: new Date().toISOString()
});

// Función para generar una nueva versión (helper para desarrollo)
export const generateNextVersion = (type = 'patch') => {
  const [major, minor, patch] = APP_VERSION.split('.').map(Number);
  
  switch (type) {
    case 'major':
      return `${major + 1}.0.0`;
    case 'minor':
      return `${major}.${minor + 1}.0`;
    case 'patch':
    default:
      return `${major}.${minor}.${patch + 1}`;
  }
};

export default {
  APP_VERSION,
  CACHE_CONFIG,
  DEV_CONFIG,
  isVersionCompatible,
  getVersionInfo,
  generateNextVersion
};
